import classNames from "classnames";
import ButtonDropdown from "components/uiComponents/ButtonDropdown";
import { useState } from "react";
import "./Select.scss";
import { useCallback } from "react";

const Select = (
    {
        title,
        options,
        selectedValue,
        setSelectedValue,
        isBold,
        placeholder,
        textSize = 'lg',
        dropdownVerticalPosition="bottom",
        customContainerClass,
    }
  ) => {

  const [isDropdownShow, setIsDropdownShow] = useState(false);

  const openSidebarHandler = useCallback(() => {
    setIsDropdownShow(true)
  },[])
  
  const closeSidebarHandler = useCallback(() => {
    setIsDropdownShow(false)
  },[])

  const renderSelect = () => {
    const _placeholder = placeholder ?? "Please Select Value";

    const selectFinalClasses = classNames(
      "column-select",
      {
        active: isDropdownShow,
      }
    );

    const titleFinalClass = classNames(
      "column-select_title",
      {
        "column-select--bold": isBold,
      }
    )

    const valueFinalClass = classNames({
      "column-select_value" : true,
      "column-select--bold": isBold,
    })

    return (
      <>
        <div
          className={selectFinalClasses}
          onClick={openSidebarHandler}
        >
          {
            title ? <div className={titleFinalClass}>{title}</div> : null 
          }
          {selectedValue?.value ? (
            <div className={valueFinalClass}>{selectedValue.value}</div>
          ) : (
            <div className="column-select_placeholder">{_placeholder}</div>
          )}
        </div>
      </>
    );
  };

  const renderOption = (item) => {
    const handleClickDropdownItem = () => {
      setIsDropdownShow(false);
      setSelectedValue(item);
    };

    const optionFinalClasses = classNames({
        "dropdown-item": true,
        "selected": item.key === selectedValue?.key
      })
    
    return (
      <div
        className={optionFinalClasses}
        onClick={handleClickDropdownItem}
        key={item.key}
      >
        {item.value}
      </div>
    );
  };

  return (
    <div className={`column-select-text--${textSize}`}>
      <ButtonDropdown
        buttonElement={renderSelect()}
        dropdownVerticalPosition={dropdownVerticalPosition}
        isFullHeight
        isFullWidth
        onCloseDropdown={closeSidebarHandler}
        customContainerClass={customContainerClass}
        dropDownCloseStatus={isDropdownShow}
      >
        {options ?
          options.map(renderOption) : null
        }
      </ButtonDropdown>
    </div>
  );
};

export default Select;
